const base64ToBlob = (
  base64: string,
  defaultMime = 'application/octet-stream'
) => {
  let mime = defaultMime;
  let base64Data = base64;

  // If it's a data URL (data:<mime>;base64,<data>)
  const dataUrlMatch = /^data:([^;]+);base64,(.*)$/i.exec(base64);
  if (dataUrlMatch) {
    mime = dataUrlMatch[1] || defaultMime;
    base64Data = dataUrlMatch[2];
  }

  // Decode base64 to binary string
  const binaryString = atob(base64Data);

  // Convert binary string to Uint8Array
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return {
    blob: new Blob([bytes], { type: mime }),
    mime,
  };
};

// [AJUSTE 30/09/2026] A URL do blob NAO e mais invalidada enquanto esta pagina viver.
//
// O QUE ACONTECIA. Quem abre um PDF em outra aba via aquela aba renderizar normalmente e,
// ao clicar em salvar, recebia do navegador "Nao foi possivel baixar - problema de rede".
// O motivo: `URL.revokeObjectURL` era chamado no onload da aba nova e, de novo, 60s depois.
// Revogar nao apaga o documento que a aba JA carregou - por isso o PDF continuava na tela e
// o defeito passava por problema de rede -, mas invalida a URL para qualquer LEITURA NOVA.
// E salvar e uma leitura nova. O mesmo valia para recarregar a aba e para imprimir.
//
// Foi reportado na 2a via de boleto do Sicoob, mas atingia todo PDF do sistema: recibo,
// nota fiscal, pedido, relatorio de cliente e contas a pagar passam por aqui.
//
// POR QUE ESPERAR O `pagehide` E NAO UM TEMPO MAIOR. Nao existe tempo certo: o usuario pode
// deixar o boleto aberto a manha inteira e so entao imprimir. Qualquer timeout volta a ser
// o mesmo defeito, so que mais raro e mais dificil de reproduzir. O blob vive enquanto a
// aba do ERP que o criou viver, que e exatamente a garantia de que a aba filha precisa; ao
// sair do sistema, tudo e liberado de uma vez.
const registrarLimpeza = (() => {
  const pendentes: string[] = [];
  let ouvindo = false;

  return (blobUrl: string) => {
    pendentes.push(blobUrl);

    if (ouvindo) return;
    ouvindo = true;

    // `pagehide` cobre o fechamento da aba e tambem a navegacao para fora do SPA -
    // situacoes em que `unload` nao dispara de forma confiavel em navegador movel.
    window.addEventListener('pagehide', () => {
      while (pendentes.length) {
        const url = pendentes.pop();
        if (url) URL.revokeObjectURL(url);
      }
    });
  };
})();

export const openBase64InNewTab = (
  base64: string,
  suggestedFilename = 'document',
  defaultMime = 'application/pdf'
) => {
  const { blob, mime } = base64ToBlob(base64, defaultMime);
  const blobUrl = URL.createObjectURL(blob);

  registrarLimpeza(blobUrl);

  const newWindow = window.open(blobUrl, '_blank');

  if (newWindow && !newWindow.closed) {
    // nada a fazer: a aba nova le a URL quando precisar (salvar, imprimir, recarregar)
  } else {
    const a = document.createElement('a');
    a.href = blobUrl;

    const ext =
      mime === 'application/pdf'
        ? '.pdf'
        : mime === 'image/png'
          ? '.png'
          : mime === 'image/jpeg'
            ? '.jpg'
            : mime === 'text/plain'
              ? '.txt'
              : '';

    a.download = suggestedFilename + ext;
    document.body.appendChild(a);
    a.click();
    a.remove();

    // O revoke imediato que havia aqui tinha o mesmo defeito, so que numa janela de tempo
    // pequena o bastante para quase nunca aparecer: o download de um arquivo grande podia
    // perder a URL no meio. Vai junto com os outros, na saida da pagina.
  }
};

export const downloadBase64 = (
  base64: string,
  suggestedFilename: string,
  mimeType: string
) => {
  const isTextFile =
    mimeType.includes('xml');

  if (isTextFile) {
    return downloadXml(base64, suggestedFilename);
  }

  const byteCharacters = atob(base64);
  const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));

  const blob = new Blob([new Uint8Array(byteNumbers)], { type: mimeType });

  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  if (mimeType.includes('xml')) {
    link.href = `data:${mimeType};charset=utf-8;base64,${base64}`;
  }
  link.download = suggestedFilename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(url);
};

const downloadXml = (base64: string, filename: string) => {
  const link = document.createElement('a');

  link.href = `data:text/xml;charset=utf-8;base64,${base64}`;
  link.download = filename.endsWith('.xml') ? filename : `${filename}.xml`;

  document.body.appendChild(link);
  link.click();
  link.remove();
};